module.exports = __webpack_public_path__ + "static/media/CZE.4ae95a62.svg";